<!-- 奖罚记录编辑 -->
<template>
    <div id="">
        <el-form :model="submitData" ref="formMsg" label-width="80px" style="width: 100%; padding-right: 30px" :rules="rules">
            <div class="form-main">
                <div class="form-left">
                    <el-form-item label="部门">
                        <el-cascader
                            style="width: 100%"
                            v-model="OrgId"
                            :options="orgSearchData"
                            :props="cascaderProps"
                            clearable
                            @change="getSIdData"
                            @visible-change="getOrgTree"
                        ></el-cascader>
                    </el-form-item>
                </div>
                <div class="form-right"></div>
            </div>
            <div class="form-main">
                <div class="form-left">
                    <el-form-item label="员工" prop="StaffId">
                        <el-select style="width: 100%" v-model="submitData.StaffId" class="search-item" filterable placeholder="请选择">
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                </div>

                <div class="form-right">
                    <el-form-item label="奖罚时间" prop="Date">
                        <el-date-picker style="width: 100%" v-model="submitData.Date" type="datetime" placeholder="选择日期"> </el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="form-main">
                <div class="form-left">
                    <el-form-item label="奖罚类型" prop="Type">
                        <el-select v-model="submitData.Type" style="width: 100%" placeholder="请选择">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="form-right">
                    <el-form-item label="分值" prop="Score">
                        <el-input type="number" style="width: 100%" controls-position="right" placeholder="" v-model.trim="submitData.Score" :min="0"
                            ><template slot="prepend">{{ submitData.Type == '0' ? '➕' : '➖' }}</template></el-input
                        >
                    </el-form-item>
                </div>
            </div>
            <div class="form-bottom">
                <el-form-item label="发生原因" prop="Reason">
                    <el-input style="width: 100%" v-model.trim="submitData.Reason"> </el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input style="width: 100%" v-model.trim="submitData.Remark"> </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div class="dialog-footer">
            <el-button class="btn-primary" @click="submitForm">提交</el-button>
            <el-button @click="cancel()">取消</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        RecordData: {
            Type: Object
        }
    },
    components: {},
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        const isNum = (rule, value, callback) => {
            const age = /^[0-9]*$/;
            if (!age.test(value)) {
                callback(new Error('分值只能为大于0数字'));
            } else {
                callback();
            }
        };
        return {
            userMsg: userMsg,
            recordData: {},
            orgSearchData: [],
            cascaderProps: {
                emitPath: false,
                expandTrigger: 'hover',
                children: 'Childrens',
                label: 'Name',
                value: 'Id',
                checkStrictly: true
            },
            SIdList: [],
            stateList: [
                { Value: 0, Text: '奖赏' },
                { Value: 1, Text: '惩罚' }
            ],
            OrgId: '',
            submitData: {
                RecordId: '',
                EntpId: userMsg.EntpId,
                StaffId: '',
                UserId: userMsg.EmployeeId,
                Type: 0,
                Date: '',
                Score: 0,
                Reason: '',
                Remark: ''
            },
            rules: {
                StaffId: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Type: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Date: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Score: [
                    { required: true, message: '该项必填且为数字类型', trigger: 'blur' },
                    { validator: isNum, trigger: 'blur' }
                ],
                Reason: [{ required: true, message: '该项必填', trigger: 'blur' }]
            }
        };
    },
    mounted() {
        this.recordData = this.RecordData;
        if (this.recordData) {
            this.OrgId = this.recordData.OrgId;
            this.submitData.StaffId = this.recordData.SId;
            this.submitData.RecordId = this.recordData.Id;
            this.submitData.Type = this.recordData.Type;
            this.submitData.Date = this.recordData.Date;
            this.submitData.Score = this.recordData.Score;
            this.submitData.Reason = this.recordData.Reason;
            this.submitData.Remark = this.recordData.Remark;
            if (this.recordData.OrgId) {
                this.getSIdData();
            }
        }
    },
    methods: {
        //获取组织树
        getOrgTree(isShow) {
            if (isShow && this.orgSearchData.length == 0) {
                this.$util
                    .axiosGet({
                        url: '/api/EntpInfoManagement/GetOrgTree'
                    })
                    .then(res => {
                        if (res.data) {
                            this.orgSearchData = this.getTreeData(res.data);
                        }
                    });
            }
        },
        // 数列
        getTreeData(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].Childrens.length < 1) {
                    data[i].Childrens = undefined;
                } else {
                    this.getTreeData(data[i].Childrens);
                }
            }
            return data;
        },
        getSIdData() {
            if (this.OrgId) {
                this.$util.getSIdListByOrg(this.OrgId).then(data => {
                    this.SIdList = data;
                });
            }
        },
        submitForm() {
            this.$refs.formMsg.validate(valid => {
                if (valid) {
                    this.$util
                        .axiosPost({
                            url: '/api/EntpInfoManagement/EditStaffRAndPRecord',
                            data: this.submitData
                        })
                        .then(res => {
                            this.$util.successMsg('保存成功');
                            setTimeout(() => {
                                this.$emit('closeDialog', true);
                            }, 1000);
                        })
                        .catch(() => {});
                }
            });
        },
        cancel() {
            this.$emit('closeDialog');
        }
    }
};
</script>
<style lang="less" scoped>
.form-main {
    display: flex;
    > div {
        width: 50%;
    }
}
.dialog-footer {
    text-align: right;
}
</style>
